import { Injectable } from "@angular/core";

import { Observable, catchError } from "rxjs";

import { ApiTemplate } from "../base/template/api.template";
import { RequestOptions, ApiResponse, TemplateHelper } from "../base";
import { Person } from "./model/user.model";

@Injectable({ providedIn: 'root' })
export class PersonApi extends ApiTemplate<Person> {
    constructor() {
        super('http.rest.identity.url', "/api/person");
    }

    findPersonByUsername(
        accountId: number,
        username: string,
        options?: RequestOptions,
    ): Observable<ApiResponse<Person | null>> {
        const url = this.urlBuilder!.builds({}, accountId, username);
        const httpOptions = TemplateHelper.buildOptions({
            ...options,
            params: {
                ...options?.params,
            },
        });

        return this.http
            .get<ApiResponse<Person | null>>(url, httpOptions)
            .pipe(
                TemplateHelper.applyRetry(options),
                catchError((err) => TemplateHelper.handleError(err))
            );
    }

}